// Assets
import avatar1 from "assets/img/avatars/avatar1.png";
import avatar2 from "assets/img/avatars/avatar2.png";
import avatar3 from "assets/img/avatars/avatar3.png";
import avatar4 from "assets/img/avatars/avatar4.png";
import avatar5 from "assets/img/avatars/avatar5.png";
import avatar7 from "assets/img/avatars/avatar7.png";
import avatar8 from "assets/img/avatars/avatar8.png";
import avatar9 from "assets/img/avatars/avatar9.png";
import avatar10 from "assets/img/avatars/avatar10.png";
// Custom icons
import {
  AdobexdLogo,
  AtlassianLogo,
  InvisionLogo,
  JiraLogo,
  SlackLogo,
  SpotifyLogo,
} from "components/Icons/Icons.js";
import { AiOutlineExclamation } from "react-icons/ai";
import {
  FaArrowDown,
  FaArrowUp,
  FaBell,
  FaCreditCard,
  FaFilePdf,
  FaHtml5,
  FaShoppingCart,
} from "react-icons/fa";
import { SiDropbox } from "react-icons/si";

export const vendorDomain = [
  {
    value: "None",
    color: "#673de6",
  },
  {
    value: "Hostinger",
    color: "#673de6",
  },
  {
    value: "Namecheap",
    color: "#f06630",
  },
  {
    value: "INet",
    color: "#2d84ef",
  },
  {
    value: "Sav",
    color: "#ffc8aa",
  },
  {
    value: "Namesilo",
    color: "#00adf2",
  },
  {
    value: "Godaddy",
    color: "#00838c",
  },
  {
    value: "Netim",
    color: "#fe8427",
  },
  {
    value: "Porkbun",
    color: "#ef7878",
  },
  {
    value: "Dynadot",
    color: "#009ddc",
  },
];


export const teamControl = [
  {
    value: "None",
  },
  {
    value: "MKT",
  },
  {
    value: "SEO",
  },
  {
    value: "DEV",
  },
];

export const typeDomain = [
  {
    value: "None",
  },
  {
    value: "PBN",
  },
  {
    value: "SEO",
  },
  {
    value: "SPAM",
  },
];


export const roleUser = [
  {
    value: "admin",
  },
  {
    value: "guide",
  },
  {
    value: "user",
  }
];

export const propertyCatagory = [
  {
    value: "Search Catagory",
  },
  {
    value: "谷歌竞价",
  },
  {
    value: "Coccoc竞价",
  },
  {
    value: "导航站",
  },
  {
    value: "Socolive Brand",
  },
];

export const statusCatagory = [
  {
    value: "Search Catagory",
  },
  {
    value: "NEW",
  },
  {
    value: "DIE",
  },
  {
    value: "LINK",
  },
];

export const groupCatagory = [
  {
    value: "Search Group",
  },
  {
    value: "NEW",
  },
  {
    value: "DIE",
  },
  {
    value: "LINK",
  },
];

export const pbnStage = [
  {
    value: "Purchased",
  },
  {
    value: "Built Site",
  },
  {
    value: "Content Completed",
  },
  {
    value: "Backlink",
  },
];

export const typeGroup = [
  {
    value: "live_football",
  },
  {
    value: "youtube_app",
  },
];





